import { userSelectionType } from "../action.types";

export const updateUserSelection = (payload) => ({
  type: userSelectionType.UPDATE_USER_SELECTION,
  payload,
});
